module.exports = __webpack_public_path__ + "static/media/Sansa Stark 1.622264bb.jpg";